import React from 'react'
import { useMutation, gql } from '@apollo/client'
import { useSnackbar } from 'notistack'
import { DateTime } from 'luxon'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Dialog from 'components/dialog'
import { useStyles } from './styles'
import CustomLuxonUtils from 'lib/CustomLuxonUtils'

const UPDATE_SESSION = gql`
  mutation UpdateSession($id: ID!, $startDateTime: ISO8601DateTime!) {
    updateSession(id: $id, startDateTime: $startDateTime) {
      message
      success
      session {
        id
        startDateTime
      }
    }
  }
`

const ConfirmModifySessionDialog = ({
  trigger,
  startDate,
  startTime,
  bookingId,
  onConfirmModifySession,
}) => {
  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()

  const [updateSession] = useMutation(UPDATE_SESSION)

  const startDateTime =
    startTime &&
    new CustomLuxonUtils().mergeDateAndTime(
      DateTime.fromJSDate(startDate).toUTC(),
      DateTime.fromJSDate(startTime).toUTC(),
    )

  return (
    <Dialog trigger={trigger} maxWidth="xs">
      {({ closeDialog }) => {
        const onModifyConfirm = async () => {
          const { data } = await updateSession({
            variables: {
              id: bookingId,
              startDateTime: startDateTime.toISO(),
            },
          })

          if (data.updateSession.success) {
            enqueueSnackbar(data.updateSession.message, { variant: 'success' })
            closeDialog()
            onConfirmModifySession && onConfirmModifySession()
          } else {
            enqueueSnackbar(data.updateSession.message, {
              variant: 'error',
            })
          }
        }
        return (
          <>
            <DialogTitle>Modify session?</DialogTitle>
            <DialogContent>
              <Typography variant="body1" color="textSecondary" gutterBottom>
                Are you sure you want to modify the original time of this
                session?
              </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button color="primary" onClick={closeDialog}>
                Cancel
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={onModifyConfirm}
              >
                Modify
              </Button>
            </DialogActions>
          </>
        )
      }}
    </Dialog>
  )
}

export default ConfirmModifySessionDialog
